import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import {
    GetAllCountries, GetAllPackingTypes,
    GetAllPorts, GetAllProductNames,
    GetAllShippingModes, GetAllBusinessPartners,
    createPackingList, UpdatePackingList, GetAllPfiList, GetAllPOInvoices, GetIncrementedPlNumber
} from '../../shared/common/graphqlQuery';
import { transformEachApiDataKeyValue } from '../../shared/hooks/transfromApiData';
import { companyData } from '../../core/auth';
import { dateFormat, routeConfig } from '../../shared/common/constant';
import './addEditPackingListInvoice.scss';
import { Select, Input, DatePicker, Button, Form, Space, InputNumber, Checkbox, message } from 'antd';
import { DeleteTwoTone, LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { api, useStore } from '../../shared/hooks/stateStore';
import cloneDeep from 'lodash/cloneDeep';
import { hideSuggestions, validateNameMessages } from '../../shared/hooks/utils';

const renderOption = (eachOption: any) => {
    return (
        <Select.Option value={eachOption.key ? eachOption.key : eachOption.value}
            key={eachOption.key ? eachOption.key : eachOption.value}>
            {eachOption.value}
        </Select.Option>
    )
}

const renderOptionPort = (eachOption: any) => {
    return (
        <Select.Option value={eachOption['_id'] ? eachOption['_id'] : eachOption.port}
            key={eachOption['_id'] ? eachOption['_id'] : eachOption.port} className="dropdown__ellipsis">
            {eachOption.port}, {eachOption.country}
        </Select.Option>
    )
};

const renderOptionManufacture = (eachOption: any) => {
    return (
        <Select.Option value={eachOption['_id'] ? eachOption['_id'] : eachOption['_id']}
            key={eachOption['_id'] ? eachOption['_id'] : eachOption['_id']} className="dropdown__ellipsis">
            {eachOption.poNumber} - {eachOption.businessPartnerId.name}
        </Select.Option>
    )
};

let tableRowdataPackingTypes = [];
let tableRowdataShippingModes = [];
let tableRowdataProductName = [];
let tableRowdataConsignee = [];
let tableRowdataCountries = [];
let tableRowdataPorts = [];
let tablePfiInvoices = [];
let tablePurchaseOrderInvoices = [];

const consigneeConst: any = {
    name: '',
    address: '',
    country: '',
    email: '',
    phoneNumber: ''
};

let PackingListStoreData;
let packingListId;
const AddEditPackingListInvoice = () => {
    const companyId = companyData().getCompanyData();
    const [consigneeDetails, setConsigneeDetails] = useState(consigneeConst);
    const [manuFactureDetailsConst, setManuFactureDetails] = useState(consigneeConst);
    const [buyerSameCheckBox, setBuyerSameCheckBox] = useState<boolean>(false);
    const [packagesType, setPackagesType] = useState<string>('');
    const [form] = Form.useForm();
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        PackingListStoreData = cloneDeep(useStore.getState().packingList);
        if (location.pathname.split('/').length === 3) {
            packingListId = location.pathname.split('/')[2];
            // || PackingListStoreData['_id']
            if (!PackingListStoreData) {
                history.push(routeConfig.allPackingList.path)
            } else {
                PackingListStoreData.date = moment(PackingListStoreData.date, dateFormat);
                setConsigneeDetails({
                    name: PackingListStoreData.businessPartnerId.name,
                    address: PackingListStoreData.businessPartnerId.address,
                    country: PackingListStoreData.businessPartnerId.country,
                    email: PackingListStoreData.businessPartnerId.email,
                    phoneNumber: PackingListStoreData.businessPartnerId.phoneNumber
                });
                PackingListStoreData.exporterRefNo = PackingListStoreData.exporterRefNo['_id'];
                PackingListStoreData.businessPartnerId = PackingListStoreData.businessPartnerId['_id'];

                PackingListStoreData.methodOfDispatch = PackingListStoreData.methodOfDispatch['_id'];
                PackingListStoreData.portOfLoading = PackingListStoreData.portOfLoading['_id'];
                PackingListStoreData.portOfDischarge = PackingListStoreData.portOfDischarge['_id'];
                PackingListStoreData.countryOfOrigin = PackingListStoreData.countryOfOrigin['_id'];

                PackingListStoreData.finalDestination = PackingListStoreData.finalDestination ? PackingListStoreData.finalDestination['_id'] : null;

                PackingListStoreData.countryOfDestination = PackingListStoreData.countryOfDestination['_id'];

                PackingListStoreData.packingListItemDetails.map(eachpackingListItemData => {
                    eachpackingListItemData.packingTypes = eachpackingListItemData.packingTypes['_id']
                    eachpackingListItemData.descriptionOfGoods = eachpackingListItemData.descriptionOfGoods['_id']
                    delete eachpackingListItemData.__typename;
                    return eachpackingListItemData;
                });
                setPackagesType(PackingListStoreData.packingListItemDetails[0].unitType || '');
                
                form.setFieldsValue(PackingListStoreData);
            }
        } else {
            PackingListStoreData = {
                packingListItemDetails: [{}]
            };
            form.setFieldsValue(PackingListStoreData);
        }
        const unsub = api.subscribe(state => {
            if (state.saveInvoice) {
                useStore.setState({ saveInvoice: 0 });
                validate();
            }
        })
        hideSuggestions();
        return () => {
            unsub();

        }
    }, []);

    const redirectBack = () => {
        history.push(routeConfig.allPackingList.path);
    }

    const onSubmittedPackingList = () => {
        redirectBack();
    }
    const onError = ({ graphQLErrors, networkError }) => {
        console.log(graphQLErrors);
        console.log(networkError);
        if (graphQLErrors[0].message === 'ACTION_NOT_ALLOWED') {
            message.error('Duplicate Invoice No. Please change the Invoice No.');
        } else {
            message.error('Something went wrong. Please try again.');
        }
    }

    // CreateNewPackingList
    const PackingListMutation = useMutationHook(createPackingList, onSubmittedPackingList, onError);
    const UpdatePackingListMutation = useMutationHook(UpdatePackingList, onSubmittedPackingList, onError);

    const CountriesQuery = useQueryHook(GetAllCountries, { companyId: companyId });
    const PackingTypesQuery = useQueryHook(GetAllPackingTypes, { companyId: companyId });
    const PortsQuery = useQueryHook(GetAllPorts, { companyId: companyId });
    const ProductNamesQuery = useQueryHook(GetAllProductNames, { companyId: companyId });
    const ShippingModesQuery = useQueryHook(GetAllShippingModes, { companyId: companyId });
    const ConsigneeQuery = useQueryHook(GetAllBusinessPartners, { companyId: companyId });
    const allConsineeData = ConsigneeQuery.data?.getAllBusinessPartners;
    const getPfiAllData = useQueryHook(GetAllPfiList, { companyId: companyId });
    const getPOData = useQueryHook(GetAllPOInvoices, { companyId: companyId });

    tableRowdataCountries = transformEachApiDataKeyValue(CountriesQuery.data?.getAllCountries, 'country');
    tableRowdataPackingTypes = transformEachApiDataKeyValue(PackingTypesQuery.data?.getAllPackingTypes, 'packingType');
    tableRowdataPorts = transformEachApiDataKeyValue(PortsQuery.data?.getAllPorts, 'port');
    tableRowdataShippingModes = transformEachApiDataKeyValue(ShippingModesQuery.data?.getAllShippingModes, 'shippingMode');
    tableRowdataProductName = transformEachApiDataKeyValue(ProductNamesQuery.data?.getAllProductNames, 'productName')
    tableRowdataConsignee = transformEachApiDataKeyValue(ConsigneeQuery.data?.getAllBusinessPartners, 'name');
    tablePfiInvoices = transformEachApiDataKeyValue(getPfiAllData.data?.getAllPFIs, 'invoiceNumber');
    tablePurchaseOrderInvoices = transformEachApiDataKeyValue(getPOData.data?.getAllPurchaseOrders, 'poNumber');

    useEffect(() => {
        if (location.pathname.split('/').length === 3) {
            onChangeManufacture();
        }
    }, [getPOData.data?.getAllPurchaseOrders]);

    const onChangeManufacture = () => {
        const manufactureDetailsId = form.getFieldValue('manufactureDetails');
        const manuFactureIndex = getPOData.data?.getAllPurchaseOrders.findIndex((eachPOInvoice) => eachPOInvoice['_id'] === manufactureDetailsId);
        if(manuFactureIndex != undefined && manuFactureIndex !== -1) {
            setManuFactureDetails(getPOData.data?.getAllPurchaseOrders[manuFactureIndex].businessPartnerId);
        }
    }
    const constPLNumber = useQueryHook(GetIncrementedPlNumber, { companyId: companyId });
    if (PackingListStoreData && !PackingListStoreData['_id'] && constPLNumber.data?.getIncrementedPlNumber) {
        PackingListStoreData = {
            invoiceNumber: constPLNumber.data?.getIncrementedPlNumber
        };
        form.setFieldsValue(PackingListStoreData);
    }

    const onChangeConsignee = () => {
        const businessPartnerId = form.getFieldValue('businessPartnerId');
        const indexConsignee = allConsineeData.findIndex(eachConsigneeData => eachConsigneeData['_id'] === businessPartnerId);
        const currentConsigneeDetail = allConsineeData[indexConsignee];
        setConsigneeDetails({
            name: currentConsigneeDetail.name,
            address: currentConsigneeDetail.address,
            country: currentConsigneeDetail.country,
            email: currentConsigneeDetail.email,
            phoneNumber: currentConsigneeDetail.phoneNumber
        });

        if (buyerSameCheckBox) {
            form.setFieldsValue({
                buyer: {
                    name: currentConsigneeDetail.name,
                    address: currentConsigneeDetail.address
                }
            })
        }
    }

    const onFinish = (values: any) => {
        const PackingListData = values;
        PackingListData.date = moment(PackingListData.date).format(dateFormat).toString();
        if (!UpdatePackingListMutation.loading && !PackingListMutation.loading) {
            if (PackingListStoreData && PackingListStoreData['_id']) {
                UpdatePackingListMutation.callMutation({ variables: { companyId, packingListId: PackingListStoreData['_id'], input: { ...PackingListData, companyId } } })
            } else {
                PackingListMutation.callMutation({ variables: { packingListInput: { ...PackingListData, companyId } } })
            }
        }
    }

    const validate = () => {
        form.validateFields().then(data => {
            onFinish(form.getFieldsValue());
        }
        ).catch(error => {

        });
    }

    const onChangeBuyer = (e) => {
        setBuyerSameCheckBox(e.target.checked);
        const businessPartnerId = form.getFieldValue('businessPartnerId');
        if (businessPartnerId) {
            form.setFieldsValue({
                buyer: {
                    name: consigneeDetails.name,
                    address: consigneeDetails.address
                }
            });
        } else {
            message.warn('Please select Consignee. On selecting consingee, Buyer will be updated.');
        }
    }

    const calTotalWeight = (index) => {
        let packingListItemDetails = form.getFieldValue('packingListItemDetails');
        packingListItemDetails[index].totalGrossWeight = (packingListItemDetails[index].weightOfPallet || 0) + (packingListItemDetails[index].netWeight || 0) + (packingListItemDetails[index].tareWeight || 0)
        form.setFieldsValue({
            packingListItemDetails
        });
    }

    const onChangePackageType = (index) => {
        let packingListItemDetails = form.getFieldValue('packingListItemDetails');
        setPackagesType(packingListItemDetails[0].unitType || '');
    }

    const onChangePfiInvoice = () => {
        const pfiId = form.getFieldValue('exporterRefNo');
        const pfiDataIndex = getPfiAllData.data?.getAllPFIs.findIndex(eachPfiData => eachPfiData['_id'] === pfiId);
        const currentPfiData = getPfiAllData.data?.getAllPFIs[pfiDataIndex];
        const packingListItemDetails = cloneDeep(currentPfiData.pfiItemDetails);
        packingListItemDetails.map(eachPfiItemData => {
            eachPfiItemData.packingTypes = eachPfiItemData.packingTypes['_id'];
            eachPfiItemData.descriptionOfGoods = eachPfiItemData.descriptionOfGoods['_id'];
            eachPfiItemData.noOfPackages = eachPfiItemData.noOfPackages;

            delete eachPfiItemData.unitType;
            delete eachPfiItemData.rate;
            delete eachPfiItemData.comments;
            delete eachPfiItemData.amount;
            delete eachPfiItemData.__typename;
            return eachPfiItemData;
        });
        form.setFieldsValue({
            date: moment(currentPfiData.date, dateFormat),
            buyer: {
                name: buyerSameCheckBox ? currentPfiData.businessPartner.name : currentPfiData.buyer.name,
                address: buyerSameCheckBox ? currentPfiData.businessPartner.address : currentPfiData.buyer.address
            },
            businessPartnerId: currentPfiData.businessPartner['_id'],
            customerPoNumber: currentPfiData.customerPoNumber,
            methodOfDispatch: currentPfiData.shippingMode['_id'],
            countryOfOrigin: currentPfiData.countryOfOrigin['_id'],
            countryOfDestination: currentPfiData.countryOfDestination['_id'],
            vesselNo: currentPfiData.vesselNo,
            portOfLoading: currentPfiData.portOfLoading['_id'],
            portOfDischarge: currentPfiData.portOfDestination['_id'],
            finalDestination: currentPfiData.finalDestination ? currentPfiData.finalDestination['_id'] : null,
            packingListItemDetails: packingListItemDetails,
            termsAndConditions: currentPfiData.termsAndConditions,
        });
        setConsigneeDetails({
            name: currentPfiData.businessPartner.name,
            address: currentPfiData.businessPartner.address,
            country: currentPfiData.businessPartner.country,
            email: currentPfiData.businessPartner.email,
            phoneNumber: currentPfiData.businessPartner.phoneNumber
        });
    }

    return (
        <Form name="basic" form={form} onFinish={onFinish} validateMessages={validateNameMessages} initialValues={null} className="form document-form" scrollToFirstError={true}>
            <div className="document-layout__page document-edit-view">
                <h3 className="document-layout__title">
                    Packing List
                </h3>
                <div className="whole__document document-layout__content">
                    <div className="document-layout__section invoice__grid__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Invoice No.</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="invoiceNumber" rules={[{ required: true, whitespace: true, message: 'Invoice No. is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section invoice__date__grid__label">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">PFI Date</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="date" rules={[{ required: true, message: 'PFI Date is missing' }]}>
                                    {/* <Input autoComplete="off" className="document-edit-block__input " /> */}
                                    <DatePicker className="document-edit-block__input " format={dateFormat} placeholder={dateFormat} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section exporter__ref__grid__label">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Exporter Ref No.</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="exporterRefNo" rules={[{ required: true, whitespace: true, message: 'Exporter Ref No. is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Exporter ref no"
                                        optionFilterProp="children"
                                        onChange={onChangePfiInvoice}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tablePfiInvoices.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section po__no__grid__label">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Customer PO No.</label>
                            <div className="document-edit-block__content">
                                {/* <Form.Item name="poNumber">
                                    <Select
                                        showSearch
                                        // placeholder="Select Exporter ref no"
                                        optionFilterProp="children"
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tablePurchaseOrderInvoices.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item> */}
                                <Form.Item name="customerPoNumber">
                                    <Input autoComplete="off" className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section  consignee__grid ">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Consignee</label>
                            <div className="document-edit-block__content">
                                {/* //rules={[{ required: true, whitespace: true, message: ' is missing' }]} */}
                                <Form.Item name="businessPartnerId" rules={[{ required: true, whitespace: true, message: 'Consignee is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Consignee"
                                        optionFilterProp="children"
                                        onChange={onChangeConsignee}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataConsignee.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="document-edit-block__content">
                                <div className="document-edit-block__contact">
                                    <div className="document-edit-block__contact-info">
                                        <div>{consigneeDetails.name}</div>
                                        <div>{consigneeDetails.address}</div>
                                        <div>{consigneeDetails.country}</div>
                                        <div>{consigneeDetails.email}</div>
                                        <div>{consigneeDetails.phoneNumber}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section  buyer__grid">
                        <div className="document-edit-block">
                            <span className="document-edit-block__label">
                                <label>
                                    Buyer
                                </label>
                                <span style={{ float: "right" }}>
                                    <Checkbox onChange={onChangeBuyer}>
                                        Same As Consignee
                                    </Checkbox>
                                </span>
                            </span>
                            <div className="document-edit-block__content">
                                <label className="document-edit-block__label">Name</label>
                                <div className="document-edit-block__content">
                                    <Form.Item name={['buyer', 'name']} rules={[{ required: true, whitespace: true, message: 'Buyer Name is missing' }]}>
                                        <Input autoComplete="off" className="document-edit-block__input " disabled={buyerSameCheckBox} />
                                    </Form.Item>
                                </div>
                                <label className="document-edit-block__label">Address</label>
                                <div className="document-edit-block__content">
                                    <Form.Item name={['buyer', 'address']} >
                                        {/* rules={[{ required: true, whitespace: true, message: 'Buyer Address is missing' }]} */}
                                        <Input className="document-edit-block__input " disabled={buyerSameCheckBox} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section  method__dispatch__grid">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Method of Dispatch</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="methodOfDispatch" rules={[{ required: true, whitespace: true, message: 'Method of Dispatch is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Method of Dispatch"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataShippingModes.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section vessel__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Vessel/Flight No</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="vesselNo" >
                                    {/* rules={[{ required: true, whitespace: true, message: 'Vessel/Flight No is missing' }]} */}
                                    <Input autoComplete="off" className="document-edit-block__input " placeholder={'Vessel/Flight No'} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section delivery__schedule__grid">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Final Destination</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="finalDestination">
                                    <Select
                                        showSearch
                                        placeholder="Final Destination of country"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataCountries.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section currency__grid">
                        <div className="document-edit-block">
                        </div>
                    </div>

                    <div className="document-layout__section origin__country__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Origin Country</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="countryOfOrigin" rules={[{ required: true, whitespace: true, message: 'Origin Country is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Origin of country"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataCountries.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>

                        </div>
                    </div>
                    <div className="document-layout__section destination__country__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Destination Country </label>
                            <div className="document-edit-block__content">
                                <Form.Item name="countryOfDestination" rules={[{ required: true, whitespace: true, message: 'Destination Country is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Destination of country"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataCountries.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>

                        </div>
                    </div>
                    <div className="document-layout__section delivery__term__grid">
                        <div className="document-edit-block" >
                        </div>
                    </div>
                    <div className="document-layout__section port__loading__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Port of Loading</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="portOfLoading" rules={[{ required: true, whitespace: true, message: 'Port of Loading is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Port of Loading"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {PortsQuery.data?.getAllPorts.map((eachOption: any) => (
                                            renderOptionPort(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section port__destination__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Port of Destination</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="portOfDischarge" rules={[{ required: true, whitespace: true, message: 'Port of Destination is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Port of Destination"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {PortsQuery.data?.getAllPorts.map((eachOption: any) => (
                                            renderOptionPort(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section payment__term_grid">
                        <div className="document-edit-block" >

                        </div>
                    </div>
                    <div className="document-layout__section primary_product__table__grid">
                        <div className="document-edit-block__table">
                            <div className="document-edit-block__table-header">
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Description of Goods
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Packing Type
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Net Quantity (in Metric Ton)
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    No of Packages
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Packages Type
                                </div>
                            </div>
                        </div>
                        <Form.List name="packingListItemDetails">
                            {(fields, { add, remove }) => {
                                return (
                                    <div>
                                        {fields.map((field, index) => (
                                            <>
                                                <Form.Item
                                                    required={false}
                                                    key={field.key}>
                                                    {fields.length > 1 ? (
                                                        <div className="document-edit-block__table-content-row-actions document-edit-block__table-content-row-actions--left">
                                                            <DeleteTwoTone
                                                                className="document-edit-block__table-content-row-action "
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                }}
                                                            />
                                                        </div>) : null}
                                                    <Space key={field.key} style={{ marginBottom: 8, width: '100%' }} align="start">
                                                        <div className="document-edit-block__table-content" style={{ width: '100%' }}>
                                                            <div className="document-edit-block__table-content-row document-edit-block__table-content-row--draggable" style={{ width: '100%' }}>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'descriptionOfGoods']}
                                                                        fieldKey={[field.fieldKey, 'descriptionOfGoods']}
                                                                        rules={[{ required: true, whitespace: true, message: 'Description Of Goods is missing' }]}
                                                                    >
                                                                        {/* tableRowdataProductName */}
                                                                        <Select
                                                                            showSearch
                                                                            disabled
                                                                            placeholder="Description Goods"
                                                                            optionFilterProp="children"
                                                                            // onChange={(event) => onChangeProductName(index)}
                                                                            // onFocus={onFocus}
                                                                            // onBlur={onBlur}
                                                                            // onSearch={onSearch}
                                                                            className="my-selector-class"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {tableRowdataProductName.map((eachOption: any) => (
                                                                                renderOption(eachOption)
                                                                            ))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'packingTypes']}
                                                                        fieldKey={[field.fieldKey, 'packingTypes']}
                                                                        rules={[{ required: true, whitespace: true, message: 'Packing Type is missing' }]}
                                                                    >
                                                                        <Select
                                                                            showSearch
                                                                            disabled
                                                                            placeholder="Packing Type"
                                                                            optionFilterProp="children"
                                                                            // onFocus={onFocus}
                                                                            // onBlur={onBlur}
                                                                            // onSearch={onSearch}
                                                                            className="my-selector-class"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {tableRowdataPackingTypes.map((eachOption: any) => (
                                                                                renderOption(eachOption)
                                                                            ))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'quantity']}
                                                                        fieldKey={[field.fieldKey, 'quantity']}
                                                                        rules={[{ required: true, message: 'Quantity is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'noOfPackages']}
                                                                        fieldKey={[field.fieldKey, 'noOfPackages']}
                                                                        rules={[{ required: true, message: 'No Of Packages is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'unitType']}
                                                                        fieldKey={[field.fieldKey, 'unitType']}
                                                                        rules={[{ required: true, whitespace: true, message: 'Package Types is missing' }]}
                                                                    >
                                                                        <Input autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => onChangePackageType(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Space>
                                                </Form.Item>
                                            </>
                                        ))}
                                        {/* <div className="flex">
                                            <div className="document-edit-block__table-button">
                                                <Button type="primary" ghost onClick={() => { add(); }}>
                                                    Add Line
                                                </Button>
                                            </div>
                                        </div> */}
                                    </div>
                                );
                            }}
                        </Form.List>
                    </div>
                    <div className="document-layout__section secondary_product__table__grid">
                        <div className="document-edit-block__table">
                            <div className="document-edit-block__table-header">
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    No Of Pallets
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Weight Of Pallet
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Net Weight (kgs)
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Tare Weight (Kgs)
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_20">
                                    Total Gross Weight (Kgs)
                                </div>
                            </div>
                        </div>
                        <Form.List name="packingListItemDetails">
                            {(fields, { add, remove }) => {
                                return (
                                    <div>
                                        {fields.map((field, index) => (
                                            <>
                                                <Form.Item
                                                    required={false}
                                                    key={field.key}>
                                                    {fields.length > 1 ? (
                                                        <div className="document-edit-block__table-content-row-actions document-edit-block__table-content-row-actions--left">
                                                            <DeleteTwoTone
                                                                className="document-edit-block__table-content-row-action "
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                }}
                                                            />
                                                        </div>) : null}
                                                    <Space key={field.key} style={{ marginBottom: 8, width: '100%' }} align="start">
                                                        <div className="document-edit-block__table-content" style={{ width: '100%' }}>
                                                            <div className="document-edit-block__table-content-row document-edit-block__table-content-row--draggable" style={{ width: '100%' }}>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'noOfPallets']}
                                                                        fieldKey={[field.fieldKey, 'noOfPallets']}
                                                                    // rules={[{ required: true,  message: 'No Of Pallets is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'weightOfPallet']}
                                                                        fieldKey={[field.fieldKey, 'weightOfPallet']}

                                                                    // rules={[{ required: true,  message: 'Weight Of Pallet is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => calTotalWeight(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'netWeight']}
                                                                        fieldKey={[field.fieldKey, 'netWeight']}
                                                                        rules={[{ required: true, message: 'Net Weight is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => calTotalWeight(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'tareWeight']}
                                                                        fieldKey={[field.fieldKey, 'tareWeight']}
                                                                        rules={[{ required: true, message: 'Tare Weight is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => calTotalWeight(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_20 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'totalGrossWeight']}
                                                                        fieldKey={[field.fieldKey, 'totalGrossWeight']}
                                                                    // rules={[{ required: true,  message: 'No Of Packages is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" readOnly />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Space>
                                                </Form.Item>
                                            </>
                                        ))}
                                    </div>
                                );
                            }}
                        </Form.List>
                    </div>

                    <div className="document-layout__section bank__psidetail__grid_packing">
                        {/* <div className="document-edit-block" >
                            <label className="document-edit-block__label">Manufacture Details</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="manufactureDetails" rules={[{ required: true, whitespace: true, message: 'Manufacture Details is missing' }]}>
                                    <Input.TextArea className="document-edit-block__input" />
                                </Form.Item>
                            </div>
                            <div className="document-edit-block__content">
                                <div className="document-edit-block__contact">

                                </div>
                            </div>
                        </div> */}
                         <div className="document-edit-block" >
                            <label className="document-edit-block__label">Manufacture Details</label>
                            <div className="document-edit-block__content">
                                {/* getPOData.data?.getAllPurchaseOrders */}
                                <Form.Item name="manufactureDetails" rules={[{ required: true, whitespace: true, message: 'Manufacture Details is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Manufacture Details"
                                        optionFilterProp="children"
                                        onChange={onChangeManufacture}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {getPOData.data?.getAllPurchaseOrders.map((eachOption: any) => (
                                            renderOptionManufacture(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="document-edit-block__content">
                                <div className="document-edit-block__contact">
                                    <div className="document-edit-block__contact-info">
                                        <div>{manuFactureDetailsConst.name}</div>
                                        <div>{manuFactureDetailsConst.address}</div>
                                        {/* <div>{manuFactureDetailsConst.country}</div> */}
                                        <div>{manuFactureDetailsConst.email}</div>
                                        <div>{manuFactureDetailsConst.phoneNumber}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section fob__cfr__heading__grid_packing">
                        <div className="document-edit-block text__align__center" >

                        </div>
                    </div>
                    <div className="document-layout__section psitotal__fob__label__grid_packing pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Net Weight Per {packagesType} (Kgs)</label>
                        </div>
                    </div>
                    <div className="document-layout__section psitotal__fob__number__grid_packing">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['breakUpWeight', 'netWeightPerPackage']} rules={[{ required: true, message: 'Net Weight is missing' }]}>
                                    <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section exchange__rate__label__grid_packing pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Gross Weight Per {packagesType} (Kgs)</label>
                        </div>
                    </div>
                    <div className="document-layout__section exchange__rate__number__grid_packing">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['breakUpWeight', 'grossWeightPerPackage']} rules={[{ required: true, message: 'Gross Weight is missing' }]}>
                                    <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section total__fob__price__inr__grid_packing pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Tare Weight Per {packagesType} (Kgs)</label>
                        </div>
                    </div>

                    <div className="document-layout__section total__fob__price__inr__number__grid_packing">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['breakUpWeight', 'tareWeightPerPackage']} rules={[{ required: true, message: 'Tare Weight is missing' }]}>
                                    <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section container__label__grid_pl pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Container No</label>
                        </div>
                    </div>
                    <div className="document-layout__section container__number__grid_pl">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['containerNo']}>
                                     <Input autoComplete="off" className="document-edit-block__input" />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section seal__label__grid_pl pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Seal No</label>
                        </div>
                    </div>
                    <div className="document-layout__section seal__number__grid_pl">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['sealNo']}>
                                     <Input autoComplete="off" className="document-edit-block__input" />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section terms__condition__grid_packing">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Terms &amp; Conditions</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="termsAndConditions">
                                    <Input.TextArea className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    {/* <div className="document-layout__section declaration__grid_packing">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Declaration</label>
                            <div className="document-edit-block__content" style={{ height: 100 }}>
                                <Form.Item name="declaration" rules={[{ required: true, whitespace: true, message: 'Declaration is missing' }]} style={{ height: '100%' }}>
                                    <Input.TextArea className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div> */}
                    <div className="document-layout__section company__signname__grid_packing pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">For, Chemtrade</label>
                        </div>
                    </div>
                    <div className="document-layout__section sign__blank__grid_packing">
                        <div className="document-edit-block" style={{ height: 100 }}>
                            <div className="document-edit-block__content">
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section signature__grid_packing pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Authorized Signature/Name</label>
                        </div>
                    </div>
                </div>
                <Form.Item style={{ marginTop: '15px' }}>
                    <Button type="primary" htmlType="submit" className="btn" ghost style={{ width: 75 }}>
                        {(UpdatePackingListMutation.loading || PackingListMutation.loading) ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>
                    <Button danger onClick={redirectBack} type="ghost">
                        Cancel
                    </Button>
                </Form.Item>
            </div>
        </Form>

    );
}
export default AddEditPackingListInvoice